// @flow

import * as React from "react";
import cx from "classnames";
import Cleave from "cleave.js/react";
import type { FieldRenderProps } from "react-final-form";

import InputWrapper from "../Shared/InputWrapper/InputWrapper";
import styles from "../Shared/Input.scss";

type InputProps = $PropertyType<FieldRenderProps, "input">;
type MetaProps = $PropertyType<FieldRenderProps, "meta">;

type DecimalInputProps = {
  additionalClasses: string,
  decimalScale: number,
  input: InputProps,
  isDisabled: boolean,
  label: string,
  leadingZeroes: boolean,
  meta: MetaProps,
  placeholder: string,
  separateThousands: boolean,
  sideSymbol?: () => React.Node,
  testId?: string,
  customInputWrapperStyles: ?string,
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
};

const DecimalInput = ({
  additionalClasses,
  decimalScale,
  input,
  isDisabled,
  label,
  leadingZeroes,
  meta,
  placeholder,
  separateThousands,
  sideSymbol,
  testId,
  customInputWrapperStyles,
  onBlur,
  ...restProps
}: DecimalInputProps) => (
  <InputWrapper
    input={input}
    meta={meta}
    sideSymbol={sideSymbol}
    isDisabled={isDisabled}
    customStyles={customInputWrapperStyles}
  >
    <Cleave
      {...input}
      className={cx(styles.input, {
        [styles.removeAdditionalPadding]: !sideSymbol,
        [additionalClasses]: !!additionalClasses
      })}
      data-testid={`decimalInput:${input.name}`}
      data-name={input.name}
      placeholder={placeholder}
      options={{
        numeral: true,
        stripLeadingZeroes: !leadingZeroes,
        numeralDecimalScale: decimalScale,
        numeralPositiveOnly: true,
        numeralThousandsGroupStyle: separateThousands ? "thousand" : "none",
        numeralDecimalMark: ",",
        delimiter: " "
      }}
      disabled={isDisabled}
      onBlur={onBlur}
      {...restProps}
    />
  </InputWrapper>
);

DecimalInput.defaultProps = {
  additionalClasses: "",
  decimalScale: 2,
  input: null,
  isDisabled: false,
  label: "",
  leadingZeroes: false,
  meta: null,
  placeholder: "",
  separateThousands: true,
  customInputWrapperStyles: "",
  onBlur: () => null
};

export default DecimalInput;
